import { Button, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'modules/Finance/Wallets/subcomponents/WalletHead/wallet-head.module.scss'

const PromisedPaymentsSwitcher = ({ id, listMode }) => {
  const { t } = useTranslation(['wallets'])
  const breakpoints = useBreakpoint()
  const pathGen = useGeneratePathI18n()

  const linkTo = useMemo(
    () =>
      pathGen(
        listMode === 'transactions'
          ? ROUTES.FINANCE_WALLET_PROMISED_PAYMENTS
          : ROUTES.FINANCE_WALLET,
        { walletID: id },
      ) + location.search,
    [listMode, id],
  )

  return (
    <Link
      to={linkTo}
      className={styles['wallet-head__button']}
    >
      <Button
        bgColor={'Interface-GU-Primary'}
        size={breakpoints.fb ? 'm' : 'l'}
        variant={'primary'}
        startIcon={<Icon name="orders" />}
        noLabel={breakpoints.sm}
      >
        {t('promised_payments_switcher.label', { context: listMode })}
      </Button>
      {breakpoints.sm && (
        <Typography
          variant={'Body-10'}
          noMargin
          color={'Label-Secondary'}
        >
          {t('promised_payments_switcher.label', { context: listMode })}
        </Typography>
      )}
    </Link>
  )
}

PromisedPaymentsSwitcher.propTypes = {
  id: PropTypes.number,
  i18n: PropTypes.string,
  listMode: PropTypes.oneOf(['transactions', 'promised-payments']),
}

export default PromisedPaymentsSwitcher
